var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"5fe79923802b805d19d39b2861d287ab81a6abf7"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// Sentry initialisation that runs in the browser.
// Compatible with @sentry/nextjs v7 (auto-detected by withSentryConfig at
// project root) and v8 (auto-detected the same way). Replay integration
// removed for cross-version compatibility — can be re-added later using the
// version-specific syntax once v7 is locked in.
import * as Sentry from '@sentry/nextjs';

// DSN is a public credential by design — it's embedded in the browser bundle.
// We still require the env var so the DSN can be rotated without a code change.
const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (!dsn) {
  // Sentry is observability, not load-bearing — degrade quietly so the app
  // still boots when the env var hasn't been set (local dev, preview deploys
  // before secrets are wired, etc.).
  // eslint-disable-next-line no-console
  console.warn('[sentry] NEXT_PUBLIC_SENTRY_DSN not set — client error reporting disabled');
} else {
  Sentry.init({
    dsn,
    environment:
      process.env.NEXT_PUBLIC_VERCEL_ENV ||
      process.env.NODE_ENV ||
      'development',
    release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
    // Sample 10% of transactions in production, all in dev
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    // Don't send PII by default; opt in when consent is given
    sendDefaultPii: false,
    beforeSend(event) {
      // Respect cookie consent — only drop events when analytics is explicitly
      // disabled. If consent is undefined we still init (so __SENTRY__ exists
      // for debugging) but defer to the user's eventual choice.
      if (typeof window !== 'undefined') {
        const consent = (window as unknown as {
          __mccConsent?: { analytics?: boolean };
        }).__mccConsent;
        if (consent && consent.analytics === false) return null;
      }
      return event;
    },
  });
}
